import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import MobileLogo from "../molecules/logo/MobileLogo";
import BrandLogo from "../organisms/sliders/BrandLogo";
import ContactButton from "../atoms/buttons/ContactButton";
import WelcomeSlider from "../organisms/sliders/WelcomeSlider";

export default function VestelIdentity() {
  const [searchParams] = useSearchParams();
  const [redirectUrl, setRedirectUrl] = useState("");
  const { t } = useTranslation();
  let countryCode = localStorage.getItem("countryCode");

  const mailto =
    countryCode === "DE"
      ? "mailto:direkt-vertrieb@vestel-germany.de"
      : "mailto:akillidunyam@vestel.com.tr";

  useEffect(() => {
    const page = searchParams.get("page");
    if (page === "forgetPassword") {
      setRedirectUrl("/request-code?id=1&country=" + countryCode);
    } else {
      setRedirectUrl("/sign-up?id=1&country=" + countryCode);
    }
  }, []);

  return (
    <>
      <MobileLogo />
      <div className="max-[1199px]:pt-0 max-[1199px]:p-16 max-[640px]:p-4 main-container">
        <div className="max-[1199px]:p-8 max-[640px]:p-4 identity-container rounded min-[769px]:mt-8">
          <BrandLogo country={countryCode} />
          <WelcomeSlider />
          <div className="flex justify-center customer-action-btn max-[640px]:p-2">
            <button
              onClick={() => (window.location.href = redirectUrl)}
              className="bg-red-500 text-white rounded text-lg font-league-medium"
            >
              {t("identity.sign-in-or-sign-up")}
            </button>
          </div>

          {countryCode !== "DE" ? (
            <div className="flex justify-center max-[640px]:mb-12 sm:px-0 sm:py-4 md:p-4 !pt-0">
              <ContactButton type="mail" href={mailto} />
              <ContactButton
                type="whatsapp"
                href="https://wa.me/908502224123"
              />
            </div>
          ) : (
            <>
              <div className="flex justify-center max-[640px]:mb-12 sm:px-0 sm:py-4 md:p-4 !pt-0 w-full">
                <ContactButton type="mail" href={mailto} />
              </div>
              <div className="flex justify-center">
                <a
                  className="flex flex-row sm:leading-1 md:leading-2 items-center space-x-2 px-1 mx-1 font-small text-center font-league-light w-6/6 max-w-full underline"
                  href={
                    process.env.REACT_APP_GLOBAL_STORE_URL + "content/impressum"
                  }
                >
                  <span className="mx-auto text-center pt-2">
                    {t("identity.impressum")}
                  </span>
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}
